module.exports = __webpack_public_path__ + "img/39.8647f8c3.png";